export function attachIframeScrollListener(iFrame, handler) {
  try {
    const frameWindow = iFrame && iFrame.contentWindow;
    if(!frameWindow || typeof frameWindow.addEventListener !== 'function') {
      return false;
    }

    frameWindow.addEventListener('scroll', handler);
    return true;
  } catch (error) {
    if(error && error.name === 'SecurityError') {
      console.warn('PEP-Render: cross-origin iframe scroll listener unavailable');
      return false;
    }

    throw error;
  }
}
